import React from 'react'

export const ConnectionIssue = () => (
  <>You have a connection issue. Some information could be unavailable.</>
)
